import {
  getCategoryId,
  getCategoryMenuId,
  getCategoryName,
  getItemCategoryIds,
  getItemId,
  getItemName,
  getMenuId,
  getMenuName,
  isVisibleSkuEntity,
} from 'features/Sku/Items/SkuMenuData.normalizers';

export const SELECTION_ROW_TYPE = { ITEM: 'item', MENU: 'menu' };

export const MENU_COLLAPSE_THRESHOLD = 5;

const byName = (a, b) => a.name.localeCompare(b.name);

const byMenuThenCategoryThenName = (a, b) =>
  a.menuName.localeCompare(b.menuName) || a.categoryName.localeCompare(b.categoryName) || byName(a, b);

export const toItemCatalogue = ({ menus = [], categories = [], items = [] }) => {
  const categoryById = new Map(
    categories.filter(isVisibleSkuEntity).map(category => [getCategoryId(category), category])
  );
  const menuNameById = new Map(menus.map(menu => [getMenuId(menu), getMenuName(menu)]));

  const catalogue = items.filter(isVisibleSkuEntity).flatMap(item => {
    const category = getItemCategoryIds(item)
      .map(categoryId => categoryById.get(categoryId))
      .find(Boolean);
    if (!category) return [];

    const menuId = getCategoryMenuId(category);
    if (!menuNameById.has(menuId)) return [];

    return [
      {
        id: getItemId(item),
        name: getItemName(item),
        categoryName: getCategoryName(category),
        menuId,
        menuName: menuNameById.get(menuId),
      },
    ];
  });

  return catalogue.sort(byMenuThenCategoryThenName);
};

export const rollUpSelection = (items, selectedIds) => {
  const selected = new Set(selectedIds);
  const menus = [];
  const byMenu = new Map();

  items.forEach(item => {
    if (!byMenu.has(item.menuId)) {
      byMenu.set(item.menuId, []);
      menus.push({ id: item.menuId, name: item.menuName });
    }
    byMenu.get(item.menuId).push(item);
  });

  const menuRows = [];
  const itemRows = [];

  menus.forEach(menu => {
    const selectedItems = byMenu.get(menu.id).filter(item => selected.has(item.id));
    if (selectedItems.length === 0) return;

    selectedItems.sort(byName);

    if (selectedItems.length >= MENU_COLLAPSE_THRESHOLD) {
      menuRows.push({
        type: SELECTION_ROW_TYPE.MENU,
        id: menu.id,
        name: menu.name,
        itemCount: selectedItems.length,
        itemIds: selectedItems.map(item => item.id),
      });
      return;
    }

    itemRows.push(
      ...selectedItems.map(item => ({
        type: SELECTION_ROW_TYPE.ITEM,
        id: item.id,
        name: item.name,
        categoryName: item.categoryName,
        menuName: item.menuName,
      }))
    );
  });

  return [...menuRows.sort(byName), ...itemRows.sort(byName)];
};

export const selectionAfterRemoval = (selectedIds, row) => {
  const removed = new Set(row.type === SELECTION_ROW_TYPE.MENU ? row.itemIds : [row.id]);
  return selectedIds.filter(id => !removed.has(id));
};
